import DeveloperBoard from '@mui/icons-material/DeveloperBoard';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DeveloperBoardIcon(props: FixMe) {
  return <DeveloperBoard {...props} />;
}

export default DeveloperBoardIcon;
